module.exports = __webpack_public_path__ + "img/SWP_Shield_02.64134918.png";